import { render, staticRenderFns } from "./LcrChangeRequestListingBlockInView.vue?vue&type=template&id=20255a08&"
import script from "./LcrChangeRequestListingBlockInView.vue?vue&type=script&lang=js&"
export * from "./LcrChangeRequestListingBlockInView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports